import React from 'react';
import Image from '../../../../atoms/Image';
import check from '../../data/check.png';
export default function Completion(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
    src: check,
    className: "checkmark",
    size: "small"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "modal-header centered-content"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "centered-content body-text blue-color"
  }, description));
}